!function(n){var e=null,t="is-active",r=null,c=null;function l(n){n.preventDefault();var e,r=n.currentTarget.parentElement.parentElement;c!==r?(!function(){if(void 0===c)return this;c.classList.remove(t)}(),(e=r).classList.add(t),c=e):c.classList.remove(t)}n.AccordionJS=function(n){var o=n||"the-accordion";null!==(e=document.querySelector("#"+o))&&(r=e.querySelectorAll(".accordion-panel")).length>0&&function(){for(c=function(){for(var n=0;n<r.length;n++)if(r[n].classList.contains(t))return r[n]}(),i=0;i<r.length;i++){var n=r[i];n.querySelector("a").addEventListener("click",l)}}()}}(window);
function tabtab(e,t){var a=document.querySelectorAll(e+" li");function r(e){for(var r=0;r<a.length;r++)a[r].classList.remove("is-active");var i=e.target;i.parentNode.classList.add("is-active");var l=document.getElementById(i.href.split("#")[1]),n=document.querySelectorAll(t+" .tab-pane");for(r=0;r<n.length;r++)n[r].classList.add("is-hidden");l.classList.remove("is-hidden"),e.preventDefault()}for(var i=0;i<a.length;i++)a[i].addEventListener("click",r)}


var ls=!1;function lsTest(){var t="test";try{return localStorage.setItem(t,t),localStorage.removeItem(t),!0}catch(t){return!1}}ls=!0===lsTest();


if (navigator.userAgent.indexOf("Chrome") !== -1 && navigator.userAgent.indexOf("Windows") !== -1){
 document.querySelector('html').classList.add('chromeWindows');
}

var apitag = '';
var siteHost = window.location.host;
if(siteHost == '80stees-dev.myshopify.com'){
 apitag = '80stees-dev.myshopify.com'
}else if(siteHost == 'www.80stees.com' || '80stees.com'){
 apitag = 'www-90stees-com.myshopify.com'
}

/*
	By Osvaldas Valutis, www.osvaldas.info
	Available for use under the MIT License
*/

/* eslint-disable no-unused-vars */
(function (document, window) {
  var el = document.body || document.documentElement,
      s = el.style,
      prefixAnimation = '',
      prefixTransition = '';
  if (s.WebkitAnimation == '') prefixAnimation = '-webkit-';
  if (s.MozAnimation == '') prefixAnimation = '-moz-';
  if (s.OAnimation == '') prefixAnimation = '-o-';
  if (s.WebkitTransition == '') prefixTransition = '-webkit-';
  if (s.MozTransition == '') prefixTransition = '-moz-';
  if (s.OTransition == '') prefixTransition = '-o-';
  Object.defineProperty(Object.prototype, 'onCSSAnimationEnd', {
    value: function value(callback) {
      var runOnce = function runOnce(e) {
        callback();
        e.target.removeEventListener(e.type, runOnce);
      };

      this.addEventListener('webkitAnimationEnd', runOnce);
      this.addEventListener('mozAnimationEnd', runOnce);
      this.addEventListener('oAnimationEnd', runOnce);
      this.addEventListener('oanimationend', runOnce);
      this.addEventListener('animationend', runOnce);
      if (prefixAnimation == '' && !('animation' in s) || getComputedStyle(this)[prefixAnimation + 'animation-duration'] == '0s') callback();
      return this;
    },
    enumerable: false,
    writable: true
  });
  Object.defineProperty(Object.prototype, 'onCSSTransitionEnd', {
    value: function value(callback) {
      var runOnce = function runOnce(e) {
        callback();
        e.target.removeEventListener(e.type, runOnce);
      };

      this.addEventListener('webkitTransitionEnd', runOnce);
      this.addEventListener('mozTransitionEnd', runOnce);
      this.addEventListener('oTransitionEnd', runOnce);
      this.addEventListener('transitionend', runOnce);
      this.addEventListener('transitionend', runOnce);
      if (prefixTransition == '' && !('transition' in s) || getComputedStyle(this)[prefixTransition + 'transition-duration'] == '0s') callback();
      return this;
    },
    enumerable: false,
    writable: true
  });
})(document, window, 0);


document.addEventListener('DOMContentLoaded', function () {
  var sizeAccordionHeader = document.getElementById('size-accordion-header');
  if(sizeAccordionHeader){
    (function(){ new AccordionJS('size-accordion-header');})();
  }
  var sizeAccordionModal = document.getElementById('size-accordion-modal');
  if(sizeAccordionModal){
    (function(){ new AccordionJS('size-accordion-modal');})();
  }
})


document.addEventListener('click', function (event) {
    if ( event.target.classList.contains( 'modal-close' ) ) {
      event.preventDefault();
      event.target.parentNode.classList.remove('is-active');
      document.getElementsByTagName( 'html' )[0].classList.remove('is-clipped');
    }
}, false);

document.onkeydown = function(evt) {
    evt = evt || window.event;
    if (evt.keyCode == 27) {
      showNavs();
      evt.target.parentNode.classList.remove('is-active');
      var modals = document.getElementsByClassName('modal');
      for(i=0;i<modals.length;i++){
        modals[i].classList.remove('is-active');
        document.getElementsByTagName( 'html' )[0].classList.remove('is-clipped');
      }
    }
};


function removeA(e){for(var n,r,f=arguments,o=f.length;o>1&&e.length;)for(n=f[--o];-1!==(r=e.indexOf(n));)e.splice(r,1);return e}

!function(t){var r,e=Object.prototype,n=e.hasOwnProperty,o="function"==typeof Symbol?Symbol:{},i=o.iterator||"@@iterator",a=o.asyncIterator||"@@asyncIterator",c=o.toStringTag||"@@toStringTag",u="object"==typeof module,h=t.regeneratorRuntime;if(h)u&&(module.exports=h);else{(h=t.regeneratorRuntime=u?module.exports:{}).wrap=w;var f="suspendedStart",s="suspendedYield",l="executing",p="completed",y={},v={};v[i]=function(){return this};var d=Object.getPrototypeOf,g=d&&d(d(P([])));g&&g!==e&&n.call(g,i)&&(v=g);var m=b.prototype=x.prototype=Object.create(v);E.prototype=m.constructor=b,b.constructor=E,b[c]=E.displayName="GeneratorFunction",h.isGeneratorFunction=function(t){var r="function"==typeof t&&t.constructor;return!!r&&(r===E||"GeneratorFunction"===(r.displayName||r.name))},h.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,b):(t.__proto__=b,c in t||(t[c]="GeneratorFunction")),t.prototype=Object.create(m),t},h.awrap=function(t){return{__await:t}},_(j.prototype),j.prototype[a]=function(){return this},h.AsyncIterator=j,h.async=function(t,r,e,n){var o=new j(w(t,r,e,n));return h.isGeneratorFunction(r)?o:o.next().then(function(t){return t.done?t.value:o.next()})},_(m),m[c]="Generator",m[i]=function(){return this},m.toString=function(){return"[object Generator]"},h.keys=function(t){var r=[];for(var e in t)r.push(e);return r.reverse(),function e(){for(;r.length;){var n=r.pop();if(n in t)return e.value=n,e.done=!1,e}return e.done=!0,e}},h.values=P,N.prototype={constructor:N,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=r,this.done=!1,this.delegate=null,this.method="next",this.arg=r,this.tryEntries.forEach(G),!t)for(var e in this)"t"===e.charAt(0)&&n.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=r)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function o(n,o){return c.type="throw",c.arg=t,e.next=n,o&&(e.method="next",e.arg=r),!!o}for(var i=this.tryEntries.length-1;i>=0;--i){var a=this.tryEntries[i],c=a.completion;if("root"===a.tryLoc)return o("end");if(a.tryLoc<=this.prev){var u=n.call(a,"catchLoc"),h=n.call(a,"finallyLoc");if(u&&h){if(this.prev<a.catchLoc)return o(a.catchLoc,!0);if(this.prev<a.finallyLoc)return o(a.finallyLoc)}else if(u){if(this.prev<a.catchLoc)return o(a.catchLoc,!0)}else{if(!h)throw new Error("try statement without catch or finally");if(this.prev<a.finallyLoc)return o(a.finallyLoc)}}}},abrupt:function(t,r){for(var e=this.tryEntries.length-1;e>=0;--e){var o=this.tryEntries[e];if(o.tryLoc<=this.prev&&n.call(o,"finallyLoc")&&this.prev<o.finallyLoc){var i=o;break}}i&&("break"===t||"continue"===t)&&i.tryLoc<=r&&r<=i.finallyLoc&&(i=null);var a=i?i.completion:{};return a.type=t,a.arg=r,i?(this.method="next",this.next=i.finallyLoc,y):this.complete(a)},complete:function(t,r){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&r&&(this.next=r),y},finish:function(t){for(var r=this.tryEntries.length-1;r>=0;--r){var e=this.tryEntries[r];if(e.finallyLoc===t)return this.complete(e.completion,e.afterLoc),G(e),y}},catch:function(t){for(var r=this.tryEntries.length-1;r>=0;--r){var e=this.tryEntries[r];if(e.tryLoc===t){var n=e.completion;if("throw"===n.type){var o=n.arg;G(e)}return o}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,n){return this.delegate={iterator:P(t),resultName:e,nextLoc:n},"next"===this.method&&(this.arg=r),y}}}function w(t,r,e,n){var o,i,a,c,u=r&&r.prototype instanceof x?r:x,h=Object.create(u.prototype),v=new N(n||[]);return h._invoke=(o=t,i=e,a=v,c=f,function(t,r){if(c===l)throw new Error("Generator is already running");if(c===p){if("throw"===t)throw r;return F()}for(a.method=t,a.arg=r;;){var e=a.delegate;if(e){var n=O(e,a);if(n){if(n===y)continue;return n}}if("next"===a.method)a.sent=a._sent=a.arg;else if("throw"===a.method){if(c===f)throw c=p,a.arg;a.dispatchException(a.arg)}else"return"===a.method&&a.abrupt("return",a.arg);c=l;var u=L(o,i,a);if("normal"===u.type){if(c=a.done?p:s,u.arg===y)continue;return{value:u.arg,done:a.done}}"throw"===u.type&&(c=p,a.method="throw",a.arg=u.arg)}}),h}function L(t,r,e){try{return{type:"normal",arg:t.call(r,e)}}catch(t){return{type:"throw",arg:t}}}function x(){}function E(){}function b(){}function _(t){["next","throw","return"].forEach(function(r){t[r]=function(t){return this._invoke(r,t)}})}function j(t){var r;this._invoke=function(e,o){function i(){return new Promise(function(r,i){!function r(e,o,i,a){var c=L(t[e],t,o);if("throw"!==c.type){var u=c.arg,h=u.value;return h&&"object"==typeof h&&n.call(h,"__await")?Promise.resolve(h.__await).then(function(t){r("next",t,i,a)},function(t){r("throw",t,i,a)}):Promise.resolve(h).then(function(t){u.value=t,i(u)},a)}a(c.arg)}(e,o,r,i)})}return r=r?r.then(i,i):i()}}function O(t,e){var n=t.iterator[e.method];if(n===r){if(e.delegate=null,"throw"===e.method){if(t.iterator.return&&(e.method="return",e.arg=r,O(t,e),"throw"===e.method))return y;e.method="throw",e.arg=new TypeError("The iterator does not provide a 'throw' method")}return y}var o=L(n,t.iterator,e.arg);if("throw"===o.type)return e.method="throw",e.arg=o.arg,e.delegate=null,y;var i=o.arg;return i?i.done?(e[t.resultName]=i.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=r),e.delegate=null,y):i:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,y)}function k(t){var r={tryLoc:t[0]};1 in t&&(r.catchLoc=t[1]),2 in t&&(r.finallyLoc=t[2],r.afterLoc=t[3]),this.tryEntries.push(r)}function G(t){var r=t.completion||{};r.type="normal",delete r.arg,t.completion=r}function N(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(k,this),this.reset(!0)}function P(t){if(t){var e=t[i];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var o=-1,a=function e(){for(;++o<t.length;)if(n.call(t,o))return e.value=t[o],e.done=!1,e;return e.value=r,e.done=!0,e};return a.next=a}}return{next:F}}function F(){return{value:r,done:!0}}}(function(){return this}()||Function("return this")());
//!function(e,n){"object"==typeof exports&&"undefined"!=typeof module?module.exports=n():"function"==typeof define&&define.amd?define(n):e.Promise=n()}(this,function(){"use strict";function e(){}function n(e){if(!(this instanceof n))throw new TypeError("Promises must be constructed via new");if("function"!=typeof e)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=undefined,this._deferreds=[],f(e,this)}function t(e,t){for(;3===e._state;)e=e._value;0!==e._state?(e._handled=!0,n._immediateFn(function(){var n=1===e._state?t.onFulfilled:t.onRejected;if(null!==n){var i;try{i=n(e._value)}catch(f){return void r(t.promise,f)}o(t.promise,i)}else(1===e._state?o:r)(t.promise,e._value)})):e._deferreds.push(t)}function o(e,t){try{if(t===e)throw new TypeError("A promise cannot be resolved with itself.");if(t&&("object"==typeof t||"function"==typeof t)){var o=t.then;if(t instanceof n)return e._state=3,e._value=t,void i(e);if("function"==typeof o)return void f(function(e,n){return function(){e.apply(n,arguments)}}(o,t),e)}e._state=1,e._value=t,i(e)}catch(u){r(e,u)}}function r(e,n){e._state=2,e._value=n,i(e)}function i(e){2===e._state&&0===e._deferreds.length&&n._immediateFn(function(){e._handled||n._unhandledRejectionFn(e._value)});for(var o=0,r=e._deferreds.length;r>o;o++)t(e,e._deferreds[o]);e._deferreds=null}function f(e,n){var t=!1;try{e(function(e){t||(t=!0,o(n,e))},function(e){t||(t=!0,r(n,e))})}catch(i){if(t)return;t=!0,r(n,i)}}var u=setTimeout;return n.prototype["catch"]=function(e){return this.then(null,e)},n.prototype.then=function(n,o){var r=new this.constructor(e);return t(this,new function(e,n,t){this.onFulfilled="function"==typeof e?e:null,this.onRejected="function"==typeof n?n:null,this.promise=t}(n,o,r)),r},n.prototype["finally"]=function(e){var n=this.constructor;return this.then(function(t){return n.resolve(e()).then(function(){return t})},function(t){return n.resolve(e()).then(function(){return n.reject(t)})})},n.all=function(e){return new n(function(n,t){function o(e,f){try{if(f&&("object"==typeof f||"function"==typeof f)){var u=f.then;if("function"==typeof u)return void u.call(f,function(n){o(e,n)},t)}r[e]=f,0==--i&&n(r)}catch(c){t(c)}}if(!e||"undefined"==typeof e.length)throw new TypeError("Promise.all accepts an array");var r=Array.prototype.slice.call(e);if(0===r.length)return n([]);for(var i=r.length,f=0;r.length>f;f++)o(f,r[f])})},n.resolve=function(e){return e&&"object"==typeof e&&e.constructor===n?e:new n(function(n){n(e)})},n.reject=function(e){return new n(function(n,t){t(e)})},n.race=function(e){return new n(function(n,t){for(var o=0,r=e.length;r>o;o++)e[o].then(n,t)})},n._immediateFn="function"==typeof setImmediate&&function(e){setImmediate(e)}||function(e){u(e,0)},n._unhandledRejectionFn=function(e){void 0!==console&&console&&console.warn("Possible Unhandled Promise Rejection:",e)},n});








window.addEventListener("DOMContentLoaded",function(){
  tabtab('#side-nav-triggers-header','#side-nav-tabs-header');
  tabtab('#side-nav-triggers-mobile','#side-nav-tabs-mobile');
  tabtab('#filter-collection-triggers','#filter-collection-tabs');
});


function removeNotificationFlag(){
  document.getElementById('privyShow-TopM').classList.remove('notif');
  document.getElementById('ps-topD').classList.remove('notif');
  if(ls){
  	localStorage.setItem('signup_notify',true);
  }
}


var searchClose = document.getElementById('searchClose');
searchClose.addEventListener('click',function(){
  showNavs();
});

var parentsNav = document.querySelectorAll('.site-nav--has-submenu');
for(var i=0;i<parentsNav.length;i++){
  var chldsNav = parentsNav[i].querySelector('ul');
  var ccount = chldsNav.childElementCount;
  parentsNav[i].setAttribute('data-child-count',ccount);
}

function quickFilter(src) {
  // Declare variables
  var input, filter, ul, li, a, i, txtValue;
  if(src=="dsk"){
    input = document.getElementById('search-launch-input');
  }else{
    input = document.getElementById('search-launch-input-mobile');
  }
  filter = input.value.toUpperCase();
  if(src=="dsk"){
    ul = document.getElementById("siteNav");
  }else{
    ul = document.getElementById("siteNavM");
  }
  li = ul.querySelectorAll('li.collection-item');
  
  for(var i=0;i<parentsNav.length;i++){
    parentsNav[i].setAttribute('data-child-vis',0);
  }
  

  //hide tab nav on value
  if(input.value != ''){
    if(src == 'dsk'){
      ul.querySelector('#tabNav').style.display="none";
    }else{
      ul.querySelector('#tabNavMobile').style.display="none";
    }
  }else{
    if(src == 'dsk'){
      ul.querySelector('#tabNav').style.display="";
    }else{
     ul.querySelector('#tabNavMobile').style.display="";
    }
  }

  for (i = 0; i < li.length; i++) {
    var pwrap = li[i].parentNode.parentNode.parentNode;
    var childvis = parseInt(pwrap.getAttribute('data-child-vis'));
    
    a = li[i].querySelector(".collection-item>a.is-flex-row>span");
    if(a != null){
      txtValue = a.textContent || a.innerText;
    }else{
      txtValue = "";
    }
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      li[i].style.display = "";
	  pwrap.setAttribute('data-child-vis',childvis+1);
    } else {
      li[i].style.display = "none";
    }
  }
  
  var curWidth = document.documentElement.clientWidth;
  

  var parentsNavs = document.querySelectorAll('.site-nav--has-submenu');
  for(var i = 0;i<parentsNavs.length;i++){
   var shw = parentsNavs[i].getAttribute('data-child-vis');
   if(shw > 0 && input.value != ''){
     parentsNav[i].style.display = "";
 	 parentsNav[i].classList.add('badger-accordion--initialized');
     parentsNav[i].classList.add('-ba-parent-is-active');
     parentsNav[i].querySelector('.badger-accordion__panel').classList.remove('-ba-is-hidden');
     parentsNav[i].querySelector('.badger-accordion__panel').classList.add('-ba-is-active');
     parentsNav[i].querySelector('.js-badger-accordion-header').setAttribute('aria-expanded','true');
     if(curWidth > 768){
       var bLazy = new Blazy({
         container: '#scrollsidebar',
         selector: 'img'
       });
     }else{
       var bLazy = new Blazy({
         container: '#mobile-nav-modal .columns',
         selector: 'img'
       });
     }
   }else if(input.value == ''){
     parentsNav[i].style.display = "";
     parentsNav[i].classList.remove('badger-accordion--initialized');
     parentsNav[i].classList.remove('-ba-parent-is-active');
     parentsNav[i].querySelector('.badger-accordion__panel').classList.remove('-ba-is-active');
     parentsNav[i].querySelector('.badger-accordion__panel').classList.add('-ba-is-hidden');
     parentsNav[i].querySelector('.js-badger-accordion-header').setAttribute('aria-expanded','false');
   }else{
     parentsNav[i].style.display = "none";
     parentsNav[i].classList.remove('badger-accordion--initialized');
     parentsNav[i].classList.remove('-ba-parent-is-active');
     parentsNav[i].querySelector('.badger-accordion__panel').classList.remove('-ba-is-active');
     parentsNav[i].querySelector('.badger-accordion__panel').classList.add('-ba-is-hidden');
     parentsNav[i].querySelector('.js-badger-accordion-header').setAttribute('aria-expanded','false');
   }
  }
  
  var bLazy = new Blazy({
    container: '.site-nav',
    selector: 'img'
  });
}

var sinput = document.getElementById('search-launch-input');
sinput.addEventListener('keyup',function(){quickFilter('dsk');});

var msinput = document.getElementById('search-launch-input-mobile');
msinput.addEventListener('keyup',function(){quickFilter('mbl');});

function filterNav() {
  /*
    var input, filter, ul, li, a, i, j, labels, toggles, tabNav, noresultsmsg, ttlcount;
    noresultsmsg = document.getElementById('noCollectionResultsMsg');
    input = document.getElementById('search-launch-input');
    filter = input.value.toUpperCase();
    ul = document.getElementById("siteNav");
    li = ul.getElementsByClassName("collection-item");
    labels = ul.getElementsByClassName("site-nav__link");
    toggles = ul.getElementsByClassName("toggle-trigger");
    tabNav = document.getElementById('tabNav');
    ttlcount = 0;
    if(input.value.length > 0){
      hideNavs();
      var std = document.getElementById('shopify-section-header');
	  std.parentNode.scrollTop = 0;
    }else{
      showNavs();
    }

    for (i = 0; i < li.length; i++) {
        a = li[i].getElementsByTagName("span")[0];
        var aitml = a.innerHTML;
        if (aitml.toUpperCase().indexOf(filter) > -1) {
            //check reslts array for match
            li[i].style.display = "block";
            ttlcount = ttlcount+1;
          
        } else {
            li[i].style.display = "none";
        }
    }
    if(ttlcount <= 0){
      noresultsmsg.classList.remove('is-hidden');
    }else{
	  noresultsmsg.classList.add('is-hidden');
    }
  */
}

function hideNavs(){
  var ul, labels, toggles, tabNav, aria;
  ul = document.getElementById("siteNav");
  ul.classList.add('filtered');
  labels = ul.getElementsByClassName("site-nav__link");
  toggles = ul.getElementsByClassName("toggle-trigger");
  aria = ul.getElementsByClassName("site-nav__submenu");
  tabNav = document.getElementById('tabNav');
  tabNav.style.display = "none";
  for(l=0;l<aria.length;l++){
    if(aria[l].hasAttribute("aria-hidden")){
        aria[l].style.maxHeight = "100%";
  		aria[l].setAttribute("aria-hidden", "false");
    }
  }
  for(j=0;j<labels.length;j++){
    labels[j].style.display = "none";
  }
  for(k=0;k<toggles.length;k++){
    toggles[k].style.display = "none";
  }
  var bLazy = new Blazy({
    container: '.site-nav',
    selector: 'img'
  });
}

function showNavs(){
  var ul, li, labels, toggles, tabNav, li, aria; 
  ul = document.getElementById("siteNav");
  ul.classList.remove('filtered');
  li = ul.getElementsByClassName("collection-item");
  labels = ul.getElementsByClassName("site-nav__link");
  aria = ul.getElementsByClassName("site-nav__submenu");
  toggles = ul.getElementsByClassName("toggle-trigger");
  tabNav = document.getElementById('tabNav');
  tabNav.style.display = "block";
  for(l=0;l<aria.length;l++){
    if(aria[l].hasAttribute("aria-hidden")){
        aria[l].style.maxHeight = '0';
  		aria[l].setAttribute("aria-hidden", "true");
    }
  }
  for(j=0;j<labels.length;j++){
    labels[j].style.display = "flex";
  } 
  for(k=0;k<toggles.length;k++){
    toggles[k].style.display = "block";
  }
  for (i = 0; i < li.length; i++) {
    li[i].style.display = "block";
  }
}


function filterNavM() {
  /*
    var input, filter, ul, li, a, i, j, labels, toggles, noresultsmsg, ttlcount;
    noresultsmsg = document.getElementById('noCollectionResultsMsgM');
    input = document.getElementById('search-launch-input-mobile');
    filter = input.value.toUpperCase();
    ul = document.getElementById("siteNavM");
    li = ul.getElementsByClassName("collection-item");
    labels = ul.getElementsByClassName("site-nav__link");
    toggles = ul.getElementsByClassName("toggle-trigger");
    ttlcount = 0;
    if(input.value.length > 0){
      hideNavsM();
    }else{
      showNavsM();
    }
    for (i = 0; i < li.length; i++) {
        a = li[i].getElementsByTagName("span")[0];
        if (a.innerHTML.toUpperCase().indexOf(filter) > -1) {
            li[i].style.display = "block";
            ttlcount = ttlcount+1;
        } else {
            li[i].style.display = "none";
        }
    }
    if(ttlcount <= 0){
      noresultsmsg.classList.remove('is-hidden');
    }else{
	  noresultsmsg.classList.add('is-hidden');
    }
    */
}

function hideNavsM(){
  var ul, labels, toggles, aria;
  ul = document.getElementById("siteNavM");
  labels = ul.getElementsByClassName("site-nav__link");
  toggles = ul.getElementsByClassName("toggle-trigger");
  aria = ul.getElementsByClassName("site-nav__submenu");
  for(l=0;l<aria.length;l++){
    if(aria[l].hasAttribute("aria-hidden")){
        aria[l].style.maxHeight = "100%";
  		aria[l].setAttribute("aria-hidden", "false");
    }
  }
  for(j=0;j<labels.length;j++){
    labels[j].style.display = "none";
  }
  for(k=0;k<toggles.length;k++){
    toggles[k].style.display = "none";
  }
  var bLazy = new Blazy({
    container: '.site-nav',
    selector: 'img'
  });
  ul.classList.add('filtered');
}

function showNavsM(){
  var ul, li, labels, toggles, li, aria; 
  ul = document.getElementById("siteNavM");
  li = ul.getElementsByClassName("collection-item");
  labels = ul.getElementsByClassName("site-nav__link");
  aria = ul.getElementsByClassName("site-nav__submenu");
  toggles = ul.getElementsByClassName("toggle-trigger");
  for(l=0;l<aria.length;l++){
    if(aria[l].hasAttribute("aria-hidden")){
        aria[l].style.maxHeight = '0';
  		aria[l].setAttribute("aria-hidden", "true");
    }
  }
  for(j=0;j<labels.length;j++){
    labels[j].style.display = "flex";
  } 
  for(k=0;k<toggles.length;k++){
    toggles[k].style.display = "block";
  }
  for (i = 0; i < li.length; i++) {
    li[i].style.display = "block";
  }
  ul.classList.remove('filtered');
}




var getCookie = function (name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
};
var customPrivyWheel = document.getElementById('pwheel-wrap');
var privyWheelView = getCookie('privyWheel');
var fathersHide = getCookie('fathersHide');




function setWheelViewed(){
    customPrivyWheel.classList.add('is-hidden');
    if(ls){
      localStorage.setItem('privyWheelViewed',true);
    }
    var CookiePDate = new Date;
    CookiePDate.setFullYear(CookiePDate.getFullYear( ) +10);
    document.cookie = 'privyWheel=viewed; expires=' + CookiePDate.toGMTString( ) + ';';
}

var privyWheelViewedLS = true;

function privyCheck(){
  if(typeof Privy == 'function') {
    if(ls){
      if(localStorage.getItem('privyWheelViewed')){
      }else{
         privyWheelViewedLS = false;
      }
    }
    if(!privyWheelView && !privyWheelViewedLS){
      //privy wheel bounce disabled for now
       //customPrivyWheel.classList.remove('is-hidden');
       //customPrivyWheel.classList.add('animate');
       //setTimeout(function(){ document.getElementById('pwheel').classList.add('bump'); }, 3500);
    }

  
    document.getElementById('ps-topD').classList.remove('is-hidden');
    document.getElementById('privyShow-TopM').classList.remove('is-hidden');
  }else{
    notYet();
  }
}
function notYet(){
  setTimeout(function(){privyCheck()}, 250);
}
privyCheck();

document.addEventListener("DOMContentLoaded", function(){
  
  var curLocal = window.location.pathname;
  var ccol = curLocal.replace('/collections/','');
  var curWidth = document.documentElement.clientWidth;
   
  if(ccol == 'new-arrivals'){
    if(document.location.href.includes('?sort_by')){
	  var srt = document.getElementById('sortby-wrapper');
      if(srt){
      	document.getElementById('sb-bestselling').classList.remove('is-hidden');
        document.getElementById('sb-new').classList.add('is-hidden');
      }
      
    }
  }
  
  if(curLocal.indexOf('/collections/') > -1){
    var paths = [];
	var allNavs = document.querySelectorAll('#siteNav .site-nav--has-submenu.js-badger-accordion');
    
    for(var i = 0; i<allNavs.length; i++){
        var fullPath = allNavs[i].querySelector('.collection-link').getAttribute('href');
        if(fullPath.indexOf('/collections/') > -1){
		   paths.push(fullPath.replace('/collections/',''));
        }
    }
    for(var i = 0; i<paths.length;i++){
      if(paths[i] == ccol){
        if(curWidth > 768){
          accrd[i].openAll();
          var scrollOffset = accrd[i].container.offsetTop - 136;
          document.querySelector('.column.is-3').scrollTop = scrollOffset;
        }else{
           var allNL = allNavs.length;
           var arcrdNum = parseInt(accrd[i].container.dataset.accrdNum);
           var macrd = arcrdNum+allNL;
           accrd[macrd].openAll();
           var tOffset = accrd[macrd].container.offsetTop - 290;
           document.querySelector('#mobile-nav-modal .modal-content').scrollTop = tOffset;

        }
      }
    }
    //custom for christmas
    if(ccol == 'all/xmas'){
        if(curWidth > 768){
          accrd[16].openAll();
          var scrollOffset = accrd[16].container.offsetTop - 140;
          document.querySelector('.column.is-3').scrollTop = scrollOffset;
        }
      }

  }
  


  var colLink = sessionStorage.getItem('collectionLink');
  if(colLink !== -1){
    var pacrdnum = sessionStorage.getItem('parent-accordion');
    if(pacrdnum != 'undefined' && pacrdnum != null){
    	accrd[pacrdnum].openAll();
    }
    var pNav = document.querySelector('[data-accrd-num="'+pacrdnum+'"]');
    if(pNav != null && pNav != 'undefined'){
    	var pNavMainChild = pNav.querySelector(".menu-label.heading");
    	var chldLinks = pNav.querySelectorAll('a.is-flex-row');
        for(var i=0;i<chldLinks.length;i++){
          var curA = chldLinks[i].getAttribute('href');
          if(curA == colLink){
            var chldLinkSelected = chldLinks[i];
            chldLinkSelected.scrollIntoView();
            document.getElementById("scrollsidebar").scrollTop -= (pNavMainChild.offsetHeight)+20;
          }
        }
    }
    
  }

  
  
  
  /* xmas free text animation */                  
  var ml9 = document.querySelectorAll('.letterss');
  for(var c = 0; c<ml9.length;c++){
  	var a = ml9[c].innerHTML;
    var b = a.replace(/([^*\s]|\w)/g, "<span class='letter'>$&</span>");
    ml9[c].innerHTML = b;
  }

  var aninum = document.querySelectorAll('.ml4wrap');
  for(var a = 0; a<aninum.length;a++){
    var tar= aninum[a].querySelectorAll('.letter');
    var tar2 = aninum[a];
    anime.timeline({loop: true})
    .add({
      targets: tar,
      scale: [0, 1],
      duration: 1500,
      elasticity: 600,
      delay: function(el, i) {
        return 95 * (i+1)
      }
    }).add({
      targets:tar2,
      duration: 1000,
      delay: 1000
    });
  }


});


const accordContainer = document.querySelectorAll("[data-accordion]");
  function handleAClickEvent(event) {
    const target = event.target;
    if (target instanceof HTMLButtonElement) {
      const panel = target.parentNode.nextElementSibling;
      const isExpanded = target.getAttribute("aria-expanded") === "true";
      console.dir(target);
      target.setAttribute("aria-expanded", `${!isExpanded}`);
      if (isExpanded) {
        console.log('expanded');
        panel.setAttribute("hidden", "");
        target.parentElement.classList.remove('is-open');
      }
      else {
        console.log('collapsed');
        panel.removeAttribute("hidden");
        target.parentElement.classList.add('is-open');
      }
    }
  }
    for(let i = 0; i<accordContainer.length;i++){
      accordContainer[i].addEventListener("click", handleAClickEvent);
    }
  //accordContainer === null || accordContainer === void 0 ? void 0 : accordContainer.addEventListener("click", handleAClickEvent);


//Scroll Elements to animate prepend scroll_animation__ to any of the https://animate.style/ animations to make it animate when scrolled into view
document.addEventListener("DOMContentLoaded", function() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.forEach(className => {
          if (className.startsWith('scroll_animation__')) {
            // Remove the prefix and set the new class name
            const animationClass = className.replace('scroll_animation__', '');
            entry.target.classList.remove(className);
            entry.target.classList.add(animationClass);
          }
        });
      }
    });
  }, { threshold: 0.1 }); // Adjust the threshold as needed

  // Select all elements with the 'scroll_animation__' prefix in their class
  const elements = document.querySelectorAll('[class*="scroll_animation__"]');
  elements.forEach(el => observer.observe(el));
});

// animate in menu on the left, staggered animation using animate.css
/*
document.addEventListener("DOMContentLoaded", function() {
  // Select all the list items
  var listItems = document.querySelectorAll('#newmenutosync>li');

  // Function to add the animation class with a delay
  function addClassWithDelay(elem, delay) {
    setTimeout(function() {
      elem.classList.add('animate__fadeInLeft');
    }, delay);
  }

  // Initial delay
  var delay = 10;
  var staggerDelay = 200; // milliseconds between each animation

  // Loop through each list item and add the class with increasing delay
  listItems.forEach(function (item) {
    addClassWithDelay(item, delay);
    delay += staggerDelay;
  });
});*/